import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * `/s/:code` — the SMS-friendly shop shortlink.
 *
 * Resolves a 4-char shop `short_code` to its subdomain and redirects
 * to the canonical `/shop/:subdomain` landing page. Kept tiny on
 * purpose: one API call, one redirect, no chrome (the shop landing
 * page renders as soon as the redirect lands).
 */
const ShopShortRedirect = () => {
  const { code } = useParams();
  const [state, setState] = useState({ subdomain: null, notFound: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/shops/resolve-short/${encodeURIComponent(code || '')}`);
        if (!res.ok) throw new Error(String(res.status));
        const j = await res.json();
        if (cancelled) return;
        if (j.subdomain) setState({ subdomain: j.subdomain, notFound: false });
        else setState({ subdomain: null, notFound: true });
      } catch {
        if (!cancelled) setState({ subdomain: null, notFound: true });
      }
    })();
    return () => { cancelled = true; };
  }, [code]);

  if (state.subdomain) return <Navigate to={`/shop/${state.subdomain}`} replace />;
  if (state.notFound) {
    return (
      <div style={{
        minHeight: '60vh', display: 'grid', placeItems: 'center',
        padding: 24, color: 'var(--mute, #6b7280)', textAlign: 'center',
      }}>
        <div>
          <h2 style={{ marginBottom: 8 }}>Shop link not found</h2>
          <p>This link may have expired or the shop is no longer active.</p>
        </div>
      </div>
    );
  }
  return (
    <div style={{
      minHeight: '60vh', display: 'grid', placeItems: 'center',
      color: 'var(--mute, #6b7280)',
    }}>
      Loading…
    </div>
  );
};

export default ShopShortRedirect;
